<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="filteredList"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
      :clearable="isClearable"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="institutionsDocDigitalState.loading"
          :style="{ opacity: institutionsDocDigitalState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay instituciones para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ListInstitutionsDocDigital',
  computed: {
    ...mapGetters('List', [
      'institutionsDocDigitalState'
    ]),
    optionSelected() {
      return this.institutionsDocDigitalState.list.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.institutionsDocDigitalState.list.length
        || this.institutionsDocDigitalState.loading;
    },
    filteredList() {
      if (!this.orderFilter) return this.institutionsDocDigitalState.list;
      return this.institutionsDocDigitalState.list
        .filter(({ order }) => order === this.orderFilter);
    }
  },
  data() {
    return {
      orderFilter: undefined
    };
  },
  methods: {
    ...mapActions('List', [
      'fetchInstitutionsDocDigital'
    ]),
    onInput(event) {
      this.$emit('input', event?.value);
      this.$emit('full-input', event);
    },
    getOption() {
      return this.institutionsDocDigitalState.list.find((option) => option.value === this.value);
    }
  },
  created() {
    this.fetchInstitutionsDocDigital();
    if (this.nested) {
      // TODO: this.clearDocuments();
      this.$watch('parentValue', (newValue, oldValue) => {
        if (newValue !== oldValue) {
          this.orderFilter = parseInt(newValue, 10);
        }
      });
    }
  },
  props: {
    name: { type: String, required: true },
    label: { type: String, default: 'Lista Instituciones Doc Digital' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    nested: { type: Boolean, default: true },
    parentValue: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    isClearable: { type: Boolean, default: true }
  },
};

</script>
